module.exports = __webpack_public_path__ + "3aa31f7356ea9db132b3b2bd8a65df44.woff";